
export enum TaskTracker {
  BUG = 'Bug' ,
  FEATURE = 'Feature',
  SUPPORT = 'Support',
  TICKET = 'Ticket'
}

export enum TaskStatus {
  NEW = 'New',
  IN_PROGRESS = 'In Progress',
  RESOLVED = 'Resolved',
  FEEDBACK = 'Feedback',
  PAUSED = 'Paused',
  CLOSE = 'Closed',
  REJECTED = 'Rejected',
  REVIEW = 'Review'
}

export enum TaskPriority {
  NORMAL = 'Normal',
  HIGH = 'High',
  URGENT = 'Urgent',
  IMMEDIATE = 'Immediate'
}

export enum TaskQuery {
  ALL = 'All',
  ASSIGNED = 'Assigned',
  REPORTED = 'Reported',
  WATCHED = 'Watched'
}

export interface TaskFilter {
  name: string;
  queryId?: number| string;
  counterKey?: string;
  count?: number;
}
// export class TaskAttribute {
//   // id: string | number;
//   // name: string;
// }
export interface TaskCategory {
  id: string;
  name: string;
  assigneeId?: number;
  assigneeName?: string;
  projectId?: string;
}

